var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 157,
    viewBox: "0 0 140 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M139.412 0H97.8458V89.2905C97.8458 106.066 83.9386 117.304 69.6804 117.304C50.198 117.304 41.577 100.92 41.577 89.2905V20.6657C41.5666 9.25221 32.2849 0 20.8349 0H0V76.4568C0 129.582 25.3261 156.248 72.1376 156.248C111.154 156.248 139.402 133.72 139.402 78.2681V0H139.412Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.690521905095308962e6e022f561622b.svg";
export { ForwardRef as ReactComponent };